import { Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useBookingStore } from "../../stores/BookingStore";
import { useCustomerStore } from "../../stores/CustomerStore";
import {
  CountryEnum,
  EDIT_ODOMETER_TEAM,
  EDIT_VEHICLE_TEAM,
  Employee,
  FUEL_REPORT_TEAM,
  IDLE_VEHICLE_EXCEPTION_TEAM,
  MANIFEST_IRS_ACCESS,
  Marken_Team,
  PRICING_TEAM_USERS,
  PodDownloadAccess,
  PodDownloadAccessUsers,
  SHIPMENT_SUMMARY_TEAM,
  UserEnum,
  isAccessible,
  isBayanTeam,
  isCNDNAccess,
  isCNDNDirectorApprovalAccess,
  isCnMainPageAccess,
  isDubaiFinance,
  isDubaiUser,
  isEditOdometerTeam,
  isEditVehicleTeam,
  isEmpLuqman,
  isFinanceApprovalAccess,
  isFuelReportTeam,
  isIdleVehicleExceptionTeam,
  isManifestIrsAccess,
  isManifestIrsUser,
  isManualWayBillAccess,
  isMarkenTeam,
  isMateenProdUser,
  isMetaAgreementReportAccess,
  isMetaIRSManifestationReportAccess,
  isNewAccessible,
  isPricingTeam,
  isProdMode,
  isShipmentSummaryTeam,
  showMetabaseReports,
} from "../../utils/app-common";
import AgreementComponent from "../AgreementComponent";
import { AlertTableLoadableComponent } from "../AlertComponent";
import { BayanTableComponentLoadable } from "../BayanComponent";
import {
  BookingComponentLoadable,
  BookingTableComponentLoadable,
} from "../BookingComponent";
import BookingDetailsComponent from "../BookingComponent/Booking/BookingDetailsComponent";
import { BulkComponentLoadable } from "../BulkComponent";
import {
  CRMRequestTableComponentLoadable,
  EnquiryTabComponentLoadable,
  EnquiryTableComponentLoadable,
  FinanceApprovalComponentLoadable,
  FinanceApprovalTabComponentLoadable,
} from "../CRMEnquiryComponents";
import { CashTabsComponentLoadable } from "../CashComponent";
import { FodCodCashTabsComponentLoadable } from "../FodCodCashComponent";
import LoadingComponent from "../CommonComponent/LoadingComponent";
import NotFoundComponent from "../CommonComponent/NotFoundComponent";
import {
  ApprovalTableComponentLoadable,
  CreditNoteTableComponentLoadable,
  FinanceApprovalTableComponentLoadable,
  DirectorTableComponentLoadable,
} from "../CreditDebitNoteComponent";
import {
  AddCustomerComplaintComponentLoadable,
  CustomerComplaintComponentLoadable,
  CustomerComplaintDetailsComponentLoadable,
} from "../CustomerComplaintComponent";
import {
  CustomerComponentLoadable,
  CustomerTableComponentLoadable,
  SubAccountDetailsComponentLoadable,
} from "../CustomerComponent/";
import ManualWaybillChargesComponent from "../CustomerComponent/TableComponent/ManualWaybillChargesComponent.tsx/ManualWaybillChargesComponent";
import {
  AgreementProductDetailsComponentLoadable,
  DetailAgreementComponentLoadable,
} from "../CustomerComponent/Customer/Sub-Account/Agreements";
import {
  DeliverySheetComponentLoadable,
  DeliverySheetDetailsComponentLoadable,
  DeliverySheetTableComponentLoadable,
} from "../DeliverySheetComponent";

import {
  ApprovalConfigComponentLoadable,
  VolumetricApprovalComponentLoadable,
} from "../VolumetricApprovalComponent";
import { OccApprovalComponentLoadable } from "../DemurrageChargesComponent";
import { DispatchWorkStationComponentLoadable } from "../DispatchWorkStationComponent";
import {
  DailyHubScanTabLoadableComponent,
  HubStorageTabLoadableComponent,
} from "../HubStorage";
import { InvoicedComponentLoadable } from "../InvoicedComponent";
import AppLayout from "../Layout/AppLayout";
import { LoginComponent } from "../LoginComponent";
import {
  ManualWaybillFormLoadable,
  ManualWaybillTableLoadable,
} from "../ManualWaybillComponent";
import {
  CityTableComponentLoadable,
  ConsigneeTableComponentLoadable,
  CountryTableComponentLoadable,
  DriverTableComponentLoadable,
  EmployeeTableComponentLoadable,
  EventTableComponentLoadable,
  ExceptionTableComponentLoadable,
  OdaTableComponentLoadable,
  ProductTableComponentLoadable,
  RegionTableComponentLoadable,
  ShipperTableComponentLoadable,
  StationTableComponentLoadable,
  TripRouteTableComponentLoadable,
  VehiclesTableLoadable,
} from "../MasterComponent";
import { BoxManagementTableComponentLoadable } from "../MasterComponent/BoxManagement";
import { TrayManagementTableComponentLoadable } from "../MasterComponent/BoxManagement copy";
import VehiclesLoginDetailsComponent from "../MasterComponent/VehiclesLoginDetails";
import {
  OperationComponentLoadable,
  OperationTableComponentLoadable,
} from "../OperationComponent";
import { PalletTableComponentLoadable } from "../PalletComponent";
import { PieceBracodeTrackingComponentLoadable } from "../PieceTrackingComponent";
import { PodDispatchComponentLoadable } from "../PodDispatch";
import {
  ProofOfBookingComponentLoadable,
  ProofOfDeliveryTableComponentLoadable,
} from "../ProofOfDelivery";
import {
  BookingReportComponentLoadable,
  CashCollectionReportComponentLoadable,
  CustomerComplaintKpiReportComponentLoadable,
  CustomerComplaintReportComponentLoadable,
  CustomerInfoReportComponentLoadable,
  DailyActivityRecapReportComponentLoadable,
  DeliverySLRReportComponentLoadable,
  DeliverySheetReportComponentLoadable,
  EmployeeReportComponentLoadable,
  ExemptionReportComponentLoadable,
  FinanceManifestReportComponentLoadable,
  IRSShipmentReportComponentComponentLoadable,
  LocateShipmentReportComponentLoadable,
  ManifestChargeReportComponentLoadable,
  MarkenClientReportComponentLoadable,
  MarkenKPIReportComponentLoadable,
  MarkenReportComponentLoadable,
  MissPickupReportComponentLoadable,
  NotDeliveryReportComponentLoadable,
  NotManifestReportComponentLoadable,
  OperationReportComponentLoadable,
  PfnReportComponentLoadable,
  PodAvailabilityReportComponentLoadable,
  PodBarcodeReportComponentLoadable,
  RTOReportComponentLoadable,
  ScanPerformanceReportComponentLoadable,
  TripPlanReportComponentLoadable,
  TripPlanWaybillReportComponentLoadable,
  VehicleReportComponentLoadable,
  VehicleTrackingReportComponentLoadable,
  WaybillsNotDeliveredReportComponentLoadable,
  WaybillsNotInvoicedReportComponentLoadable,
  WbWiseFleetDetaisReportComponentLoadable,
  FinanceManifestWithVehiclesReportComponentComponentLoadable,
  FodCodReportComponentLoadable,
} from "../ReportsComponent";
import {
  IRSSalesManManifestComponentLoadable,
  SalesManManifestComponentLoadable,
} from "../SalesManManifestComponent";
import {
  DeviceHistoryComponentLoadable,
  RealTimeMonitorComponentLoadable,
} from "../TZoneDeviceComponent";
import DeviceConfigComponent from "../TZoneDeviceComponent/DeviceConfigComponent";
import { TrackingHistoryTableLoadable } from "../TrackingHistoryComponent";
import { TripCreationComponentLoadable } from "../TripCreationComponent";
import { ApprovedWaybillsTableComponentLoadable } from "../ApprovedWaybillsComponent";
import {
  AddTripPlanComponentLoadable,
  TripPlanTableComponentLoadable,
  TripPlanTabsComponentLoadable,
} from "../TripPlanComponent";
import { VehicleAssignmentTableComponentLoadable } from "../VehicleAssignmentComponent";
// import { VehicleVisibilityTableComponentLoadable } from "../VehicleVisibilityComponent";
import AccessControlComponent from "./AccessControlComponent";
import ProtectedRoute from "./ProtectRoutes";
import DirectorApprovalTableComponent from "../CreditDebitNoteComponent/CreditNoteRequestComponent/DirectorApprovalTableComponent";
import SalesOperationComponent from "../AimsHandBookComponent/SalesOperationComponent";
import GroundOperationComponent from "../AimsHandBookComponent/GroundOperationComponent";
import { TrackingHistoryPageComponent } from "../TrackingHistoryComponent/TrackingHistoryComponent";
import IRSManifestApprovalReportComponent from "../ReportsComponent/IRSManifestApprovalReportComponent";
import { ShipmentSummaryComponentLoadable } from "../ShipmentSummary";
import { PendingPodComponentLoadable } from "../ProofOfDelivery/PendingPodComponent";
import { PreLoadPalletTableComponentLoadable } from "../PreLoadPalletComponent";
import { BarcodeCancellationComponentLoadable } from "../ChangeRequestComponents/BarcodeCancellationComponents";
import { PickupCancellationComponentLoadable } from "../ChangeRequestComponents/PickupCancellationComponents";
import { MarkenFormComponentLoadable, MarkenTableComponentLoadable } from "../MarkenComponent";
import { TrackingHistoryComponentLoadable } from "../TrackingHistory";
import { FteConfigurationComponentLoadable } from "../FteConfiguration";
import { TempMonitoringComponentLoadable } from "../TempMonitoring";
import { DiagnosticsComponentLoadable } from "../DiagnosticsComponent";
import { FuelManagementComponentLoadable, FuelAuditComponentLoadable } from "../FuelManagement";
import { WaybillExceptionTableComponentLoadable } from "../WaybillException/WaybillExceptionComponent";
import { OCCExceptionTabComponentLoadable } from "../WaybillException/OCC";
import { CustomerLegalNotesLoadableComponent } from "../CustomerLegalNotesComponent";
import { UserAuthCreationFormLoadable } from "../UserAuthCreationComponent";
import { OdometerTableLoadable } from "../OdometerComponent";
import { MetaDpsPendingReportLoadable, MetaDpsTodaysReleasedReportLoadable, MetaBookingReportLoadable, MetaDailyRecapReportLoadable, MetaManifestChargeReportLoadable, MetaFuelManagementReportLoadable, MetaPickingToOracleReportLoadable, MetaFirstMileReportLoadable, MetaMiddleMileReportLoadable, MetaLastMileReportLoadable, MetaInTransitPendingReportLoadable, MetaDriverTrackingHistoryReportLoadable, MetaTripPlanStatusReportLoadable, MetaBoxUtilizationReportLoadable, MetaFtlIdealVehicleReportLoadable, MetaDailyScanReportLoadable, MetaFleetUtilizationReportLoadable, MetaVehicleUtilizationReportLoadable, MetaCustomerShipperCoordinatesReportLoadable, MetaCustomerConsigneeCoordinatesReportLoadable, MetaBoxUtilizationByDateReportLoadable, MetaBookingNationalAddressReportLoadable, MetaEventAtHubScanReportLoadable, MetaSuspiciousScanReportLoadable, MetaOutOfLocationShipmentScanReportLoadable, MetaCourierTripStopsReportLoadable, MetaShipperConsigneeWaitingTimeReportLoadable, MetaIdleSeverityReportLoadable, MetaVehicleLoginAndLogoutDataLoadable, MetaGpiFscImpactReportLoadable, MetaHandoverSheetReportLoadable, MetaManifestConfirmationPendingReportLoadable, MetaAgreementReportLoadable, MetaPodReportLoadable, MetaPodAgreementReportLoadable, } from "../MetabaseReports";
import { DeliveryRescheduleTableComponentLoadable } from "../DeliveryRescheduleComponent";
import { AdhocReportComponentLoadable, AdhocTabsComponentLoadable, AdhocVendorMasterComponentLoadable } from "../AdhocComponent"; import { FTLTripPlanTableLoadable } from "../FTLTripPlan";
import { IdleVehiclesApprovalLoadable, IdleVehiclesDashboardLoadable } from "../IdleVehicles";
import { MapGeofenceSelectorLoadable } from "../Geofencing";
import { AdhocTripTabRoles, AdhocVendor_TripApproval_Roles, DEMURRAGE_OCC_APPROVAL_ACCESS, FTE_CONFIGURATION_ACCESS, GeoFencingAccess, PRICING_TEAM_ACCESS } from "../../utils/access-list";
import { useUserContextHook } from "../../hooks/useUserContextHook";
import { NewVehicleLoadingUnloadingReportComponentLoadable, VehicleHistoryReportComponentLoadable, VehicleLoadingUnloadingReportComponentLoadable } from "../VehicleReportComponent";
import { DriverDashboardLoadableComponent, SupervisorDashboardLoadableComponent, TrackDriverMapLoadableComponent } from "../DashboardComponent";
import DriverAssignmentReport from "../DashboardComponent/DriverDashboard/driver-assignment-report";
import { HeatMapComponentLoadable } from "../DashboardComponent/Heatmap";
import { NotificationListLoadable } from "../NotificationList";
import { InvoiceStagingLoadable } from "../InvoiceStaging";
import FFDBookingReportComponent from "../ReportsComponent/FFDBookingReportComponent";
import { CreditLimitExtensionLoadable, CreditLimitRequestsLoadable } from "../CreditLimit";
import { AimsOperationWelcome } from "../WelcomeComponent";
import AOneRoutes from "../A-oneComponenets/Routes";
import DivisionHeadApprovalTableComponent from "../CreditDebitNoteComponent/CreditNoteRequestComponent/DivisionHeadApprovalTableComponent";
import CFOApprovalTableComponent from "../CreditDebitNoteComponent/CreditNoteRequestComponent/CFOApprovalTableComponent";
import React from "react";
import { OperationContext } from "../OperationComponent/Operation/OperationDetail";
import ManifestationIRSReport from "../MetabaseReports/OpAnalyticalReports/ManifestationIRSReport";
const InvoiceStagingManifestComponentLoadable = React.lazy(() => import("../OperationComponent/Operation/OperationDetail/Manifest"));

const AppRoutes = () => {
  const location = useLocation();
  const { employeeDetail } = useUserContextHook();

  const ClearCustomerStore = useCustomerStore((state) => state.ClearStore);
  const ClearStore = useBookingStore((state) => state.ClearStore);

  const isImathulKsa = isAccessible(
    [Employee.IMATHUL_RAFI_KSA, Employee.MOHAMMAD_FAIZAN_ALAM],
    [CountryEnum.KSA],
    true
  );

  const isPricingTeamAccess = isAccessible(
    PRICING_TEAM_ACCESS,
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
    true
  );

  const isDemurrageOccApprovalAccess = isAccessible(
    DEMURRAGE_OCC_APPROVAL_ACCESS,
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
    true
  );

  const isBanderAllafi = isAccessible(
    [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
    [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
    true
  );

  useEffect(() => {
    ClearCustomerStore();
    ClearStore();
  }, [ClearCustomerStore, ClearStore, location]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route
          path="booking"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.ADMIN,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  // Changes to be made tomorrow
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF
                ]}
                isRoute
              >
                <BookingTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="add-booking"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  // Changes to be made tomorrow
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF
                ]}
                isRoute
              >
                <BookingComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="booking/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF
                ]}
                isRoute
              >
                <BookingComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="booking-detail/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.CSV,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                ]}
                isRoute
              >
                <BookingDetailsComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />

        {/* Operation */}
        <Route
          path="operation"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.MANIFESTER,
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <OperationTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="operation/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <OperationComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="operation/tracking-history/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <TrackingHistoryPageComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pre-load-pallet"
          element={
            <AccessControlComponent
              access={[
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <PreLoadPalletTableComponentLoadable />
            </AccessControlComponent>
          }
        />

        <Route
          path="pallet"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <PalletTableComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="dispatch"
          element={
            <AccessControlComponent
              access={[
                UserEnum.MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              ]}
              isRoute
            >
              <DispatchWorkStationComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="trip-routes"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <TripRouteTableComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="booking/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <BookingComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route path="/device/">
          <Route
            path="realtime"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[UserEnum.DATA_LOGGER, UserEnum.MANAGER]}
                  isRoute
                >
                  <RealTimeMonitorComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="configuration"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[UserEnum.DATA_LOGGER, UserEnum.MANAGER]}
                  isRoute
                >
                  <DeviceConfigComponent />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="history"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[UserEnum.DATA_LOGGER, UserEnum.MANAGER]}
                  isRoute
                >
                  <DeviceHistoryComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
        </Route>
        <Route path="/trip/">
          <Route
            path="trip-plan"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.MANAGER,
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.MANIFESTER,
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                    UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  ]}
                  isRoute
                >
                  <TripPlanTableComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="pod-dispatch"
            element={
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <PodDispatchComponentLoadable />
              </AccessControlComponent>
            }
          />
          <Route
            path="pod/:waybillNumber"
            element={
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
                isEmployee={PodDownloadAccess}
              >
                <ProofOfBookingComponentLoadable />
              </AccessControlComponent>
            }
          />
          <Route
            path="piece-barcode-tracking"
            element={
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <PieceBracodeTrackingComponentLoadable />
              </AccessControlComponent>
            }
          />
          <Route
            path="trip-plan/:id"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.MANAGER,
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.MANIFESTER,
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                    UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  ]}
                  isRoute
                >
                  <TripPlanTabsComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="add-trip-plan"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.MANAGER,
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  ]}
                  isRoute
                >
                  <AddTripPlanComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="trip-creation"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.MANAGER,
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  ]}
                  isRoute
                >
                  <TripCreationComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
        </Route>

        <Route
          path="deliverysheet"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OCC_SOLUTION,
                ]}
                isRoute
              >
                <DeliverySheetTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="add-deliverysheet"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <DeliverySheetComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="deliverysheet/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <DeliverySheetDetailsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="history"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <TrackingHistoryTableLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="approved-waybills"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.FINANCE]}
                isRoute
              >
                <ApprovedWaybillsTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="manual-waybills"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isManualWayBillAccess()
                    ? [
                      UserEnum.MANAGER,
                      UserEnum.DATA_LOGGER,
                      UserEnum.SALES_PERSON,
                      UserEnum.SALES_MANAGER,
                      UserEnum.SALES_DIRECTOR,
                    ]
                    : [Employee.IMRAN_PASHA, Employee.MAHTAB_ALI, Employee?.MUZAMMIL_KHAN, Employee.ASRAF_ALI, Employee.IRSHAD_ALI_VELAPURATH, Employee.VIGNESHWARAN,
                    Employee.ARCHE_MISRA,
                    Employee.HAMMAD_MAROOF, Employee.VISHNU]
                }
                isRoute
                isEmployee={!isManualWayBillAccess()}
              >
                <ManualWaybillTableLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="manual-waybill-charges"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent access={[Employee.FARAH, Employee.ALANOUD, Employee.FARAH, Employee.MATEEN_PROD]} isRoute isEmployee={true} >
                <ManualWaybillChargesComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="/vehicle-visibility"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.OPS_MANAGER]}
                isRoute
              >
                <VehicleAssignmentTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="/add-manual-waybill"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isManualWayBillAccess()
                    ? [
                      UserEnum.MANAGER,
                      UserEnum.DATA_LOGGER,
                      UserEnum.SALES_PERSON,
                      UserEnum.SALES_MANAGER,
                      UserEnum.SALES_DIRECTOR,
                    ]
                    : [
                      Employee.IMRAN_PASHA,
                      Employee.VISHNU,
                      Employee.MAHTAB_ALI,
                      Employee?.MUZAMMIL_KHAN,
                      Employee.ASRAF_ALI,
                      Employee.IRSHAD_ALI_VELAPURATH,
                      Employee.VIGNESHWARAN,
                      Employee.ARCHE_MISRA,
                      Employee.HAMMAD_MAROOF,
                      Employee.VISHNU,
                    ]
                }
                isRoute
                isEmployee={!isManualWayBillAccess()}
              >
                <ManualWaybillFormLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pod"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={PodDownloadAccess ? PodDownloadAccessUsers : [
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                ]}
                isRoute
                isEmployee={PodDownloadAccess}
              >
                <ProofOfDeliveryTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pod-dispatch"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <PodDispatchComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="sales-man-manifest"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.SALES_PERSON,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <SalesManManifestComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="irs-sales-man-manifest"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isManifestIrsUser() ? [Employee.Nouf_AlOmar] :
                    isDubaiUser()
                      ? [Employee.LARA]
                      : [
                        UserEnum.OPERATION_SUPERVISOR,
                        UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                        UserEnum.MANAGER,
                        UserEnum.OPERATION_CS_SUPERVISOR,
                        UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                        UserEnum.MANIFESTER,
                        UserEnum.OPERATION_STAFF,
                        UserEnum.OPS_MANAGER,
                        UserEnum.SALES_PERSON,
                        UserEnum.SALES_MANAGER,
                        UserEnum.SALES_DIRECTOR,
                        UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                      ]
                }
                isRoute
                isEmployee={isDubaiUser() || isManifestIrsUser()}
              >
                <IRSSalesManManifestComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="piece-barcode-tracking"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <PieceBracodeTrackingComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="/customer-complaint"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.SALES_PERSON,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <CustomerComplaintComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="/add-complaint"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.SALES_PERSON,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <AddCustomerComplaintComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="/complaint-detail/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.SALES_PERSON,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <CustomerComplaintDetailsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        {/* Master */}
        <Route
          path="oda"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <OdaTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="station"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <StationTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="country"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.OPS_MANAGER]}
                isRoute
              >
                <CountryTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="region"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.OPS_MANAGER]}
                isRoute
              >
                <RegionTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="driver"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <DriverTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="products"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.OPS_MANAGER]}
                isRoute
              >
                <ProductTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicles"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isEditVehicleTeam() ? EDIT_VEHICLE_TEAM : [
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FINANCE_CONTROLLER,
                ]}
                isEmployee={isEditVehicleTeam()}
                isRoute
              >
                <VehiclesTableLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="exception"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <ExceptionTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="city"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <CityTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="event"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                ]}
                isRoute
              >
                <EventTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="employee"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <EmployeeTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicles-details"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <VehiclesLoginDetailsComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="shippers"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <ShipperTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="consignee"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <ConsigneeTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        {/* Reports */}
        <Route
          path="booking-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE,
                ]}
                isRoute
              >
                {showMetabaseReports ? <MetaBookingReportLoadable /> : <BookingReportComponentLoadable />}
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="operation-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_STAFF,
                  UserEnum.FINANCE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                {showMetabaseReports ? <MetaDailyRecapReportLoadable /> : <OperationReportComponentLoadable />}
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="wb-wise-fleet-details-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <WbWiseFleetDetaisReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pod-availability-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <PodAvailabilityReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="exemption-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <ExemptionReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="employee-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <EmployeeReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="cash-collection-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                ]}
                isRoute
              >
                <CashCollectionReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="locate-shipment"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <LocateShipmentReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pfn-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <PfnReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="ffd-booking-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_STAFF,
                  UserEnum.FINANCE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <FFDBookingReportComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="not-delivery-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <NotDeliveryReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="rto-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <RTOReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="trip-plan-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <TripPlanReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicle-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER
                ]}
                isRoute
              >
                <VehicleReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="trip-waybill-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <TripPlanWaybillReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="delivery-sheet-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <DeliverySheetReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="marken-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMarkenTeam() ? Marken_Team : [
                  UserEnum.GATEWAY_USER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
                isEmployee={isMarkenTeam()}
              >
                <MarkenReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="marken-client-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMarkenTeam() ? Marken_Team : [
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.GATEWAY_USER
                ]}
                isRoute
                isEmployee={isMarkenTeam()}
              >
                <MarkenClientReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="marken-kpi-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMarkenTeam() ? Marken_Team : [
                  UserEnum.GATEWAY_USER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
                isEmployee={isMarkenTeam()}
              >
                <MarkenKPIReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="daily-activity-recap-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <DailyActivityRecapReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="delivery-slr-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              {/* <AccessControlComponent
                access={[
                  Employee.BALA,
                  Employee.ANIS_BISWAS,
                  Employee.GOIUSE,
                  Employee.PANDI,
                  Employee.TURKI_ALBUWAYDI,
                  Employee.MAJAD_ALI,
                  Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN,
                  Employee.BIJOY,
                  Employee.SHAJAHAN_SHAMSUDEEN,
                  Employee.ASIF_PATEL,
                  Employee.MAHTAB_ALI,
                  Employee.PRASANTH_RAMACHANDRAN,
                  Employee.MOHAMED_RIYAS,
                  Employee.IRSHAD_ALI_VELAPURATH,
                  Employee.MOHAMMED_ALJOHANI,
                ]}
                isRoute
                isEmployee={true}
              > */}
              <DeliverySLRReportComponentLoadable />
              {/* </AccessControlComponent> */}
            </Suspense>
          }
        />

        <Route
          path="miss-pickup-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              {/* <AccessControlComponent
                access={[
                  Employee.BALA,
                  Employee.ANIS_BISWAS,
                  Employee.GOIUSE,
                  Employee.PANDI,
                  Employee.TURKI_ALBUWAYDI,
                  Employee.MAJAD_ALI,
                  Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN,
                  Employee.BIJOY,
                  Employee.SHAJAHAN_SHAMSUDEEN,
                  Employee.ASIF_PATEL,
                  Employee.MAHTAB_ALI,
                  Employee.PRASANTH_RAMACHANDRAN,
                  Employee.MOHAMED_RIYAS,
                  Employee.IRSHAD_ALI_VELAPURATH,
                  Employee.MOHAMMED_ALJOHANI,
                ]}
                isRoute
                isEmployee={true}
              > */}
              <MissPickupReportComponentLoadable />
              {/* </AccessControlComponent> */}
            </Suspense>
          }
        />

        <Route
          path="scan-performance-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE
                ]}
                isRoute
              >
                <ScanPerformanceReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicle-tracking-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE
                  // UserEnum.OPERATION_SUPERVISOR_CUSTOMER_SERVICE,
                ]}
                isRoute
              >
                <VehicleTrackingReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pod-barcode-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OCC_SOLUTION,
                  // UserEnum.CUSTOMER_CARE
                  // UserEnum.OPERATION_SUPERVISOR_CUSTOMER_SERVICE,
                ]}
                isRoute
              >
                <PodBarcodeReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="fod-cod-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  // UserEnum.DATA_ANALYST,
                  // UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  // UserEnum.SALES_MANAGER,
                  // UserEnum.MANIFESTER,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  // UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  // UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  // UserEnum.FINANCE,
                  // UserEnum.FINANCE_CONTROLLER,
                  UserEnum.IT_SUPPORT,
                ]}
                isRoute
              >
                <FodCodReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="waybills-not-delivered-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <WaybillsNotDeliveredReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="waybills-not-invoiced-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <WaybillsNotInvoicedReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="/sales-opeation-handbook"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <SalesOperationComponent />
            </Suspense>
          }
        />
        <Route
          path="/ground-opeation-handbook"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <GroundOperationComponent />
            </Suspense>
          }
        />

        <Route
          path="box-management"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <BoxManagementTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="tray-management"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <TrayManagementTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        {/* LIMITED ACCESS REPORTS */}
        <Route
          path="finance-manifest-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isDubaiFinance()
                    ? [Employee.IMATHUL_RAFI]
                    : [
                      UserEnum.MANAGER,
                      UserEnum.ADMIN,
                      UserEnum.MANIFESTER,
                      UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                      UserEnum.FINANCE_CONTROLLER,
                      UserEnum.FINANCE,
                      UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                    ]
                }
                isRoute
                isEmployee={isDubaiFinance()}
              >
                <FinanceManifestReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />


        <Route
          path="finance-manifest-with-vehicles-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isDubaiFinance()
                    ? [Employee.IMATHUL_RAFI]
                    : [
                      UserEnum.MANAGER,
                      UserEnum.ADMIN,
                      UserEnum.MANIFESTER,
                      UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                      UserEnum.FINANCE_CONTROLLER,
                      UserEnum.FINANCE,
                      UserEnum.DATA_ANALYST,
                    ]
                }
                isRoute
                isEmployee={isDubaiFinance()}
              >
                <FinanceManifestWithVehiclesReportComponentComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />


        <Route
          path="not-manifest-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.ADMIN,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                ]}
                isRoute
              >
                <NotManifestReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="manifest-charge-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={!isImathulKsa ? [
                  UserEnum.MANAGER,
                  UserEnum.ADMIN,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                ] : [Employee.IMATHUL_RAFI_KSA, Employee.MOHAMMAD_FAIZAN_ALAM]}
                isEmployee={isImathulKsa}
                isRoute
              >
                {showMetabaseReports ? <MetaManifestChargeReportLoadable /> : <ManifestChargeReportComponentLoadable />}
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="customer-info-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  ...PRICING_TEAM_ACCESS,
                  Employee.ARWA,
                  Employee.BALA,
                  Employee.PANDI,
                  Employee.PRANEETH
                ]}
                isEmployee
                isRoute
              >
                <CustomerInfoReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="irs-manifest-approval-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.ADMIN,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FINANCE,
                ]}
                isRoute
              >
                <IRSManifestApprovalReportComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />

        {/* Customer */}
        <Route
          path="customer"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <CustomerTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="add-customer"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <CustomerComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="customer/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <CustomerComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="customer/:clientId/sub-account/:id"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <SubAccountDetailsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="customer/:clientId/sub-account/:id/agreement/:agreementId"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isEmpLuqman ? [Employee?.MOHAMMED_LUQMAN] : [
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                ]}
                isEmployee={isEmpLuqman}
                isRoute
              >
                <DetailAgreementComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="customer/:clientId/sub-account/:id/agreement/:agreementId/product/:productId"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isEmpLuqman ? [Employee?.MOHAMMED_LUQMAN] : [
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.MANAGER,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                ]}
                isEmployee={isEmpLuqman}
                isRoute
              >
                <AgreementProductDetailsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        {/* Alert */}
        <Route
          path="vehicle-alert"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <AlertTableLoadableComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        {/* Hub Storage */}
        <Route
          path="hub-storage"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <HubStorageTabLoadableComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="daily-hub-scan"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <DailyHubScanTabLoadableComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="cash"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isBanderAllafi ?
                  [Employee?.BANDER_ALLAFI, Employee.NOHA_KARKADAN] :
                  [
                    UserEnum.OPERATOR_CASH_COLLECTOR,
                    UserEnum.FINANCE,
                    UserEnum.FINANCE_CONTROLLER,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.OPERATION_SUPERVISOR
                  ]}
                isRoute
                isEmployee={isBanderAllafi}
              >
                <CashTabsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="fod-cod-cash"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isBanderAllafi ?
                  [Employee?.BANDER_ALLAFI, Employee.NOHA_KARKADAN] :
                  [
                    UserEnum.OPERATOR_CASH_COLLECTOR,
                    UserEnum.FINANCE,
                    UserEnum.FINANCE_CONTROLLER,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.OPERATION_SUPERVISOR
                  ]}
                isRoute
                isEmployee={isBanderAllafi}
              >
                <FodCodCashTabsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="invoice"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.FINANCE_CONTROLLER, UserEnum.FINANCE]}
                isRoute
              >
                <InvoicedComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="credit-debit-note"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isCnMainPageAccess() ? [Employee?.Abdulrahman_Jamal, Employee?.Abdulrahman_ElShafai, Employee?.AMIR_GHAAFFAR, Employee?.NOHA_KARKADAN] : [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.MANAGER]}
                isRoute
                isEmployee={isCnMainPageAccess()}
              >
                <CreditNoteTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="cd-finance-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isCNDNAccess() ? [Employee?.AMIR_GHAAFFAR, Employee.Abdulrahman_ElShafai, Employee.KAUSHIK_SAMPAT] : [UserEnum.FINANCE_CONTROLLER]}
                isRoute
                isEmployee={isCNDNAccess()}
              >
                <FinanceApprovalTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="director-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isCNDNDirectorApprovalAccess() ? [Employee?.MICHAEL_WEIDENBRUCH] : [UserEnum.MANAGER, UserEnum.SALES_DIRECTOR]}
                isRoute
                isEmployee={isCNDNDirectorApprovalAccess()}
              >
                <DirectorTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="division-head-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[Employee?.Sebastian_Sommer]}
                isRoute
                isEmployee={isCNDNAccess()}
              >
                <DivisionHeadApprovalTableComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="cfo-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[Employee?.Abdoulaye_Sarr]}
                isRoute
                isEmployee={isCNDNAccess()}
              >
                <CFOApprovalTableComponent />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="cd-notes"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isCNDNAccess() ? [Employee?.AMIR_GHAAFFAR, Employee.Abdulrahman_ElShafai, Employee?.Sebastian_Sommer, Employee?.Abdoulaye_Sarr, Employee.KAUSHIK_SAMPAT, Employee?.MICHAEL_WEIDENBRUCH] : [UserEnum.FINANCE_CONTROLLER, UserEnum.MANAGER]}
                isRoute
                isEmployee={isCNDNAccess()}
              >
                <ApprovalTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="/irs-shipment-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  !isFinanceApprovalAccess()
                    ? [UserEnum.FINANCE_CONTROLLER, UserEnum.MANAGER]
                    : [Employee.HALA]
                }
                isRoute
                isEmployee={isFinanceApprovalAccess()}
              >
                <IRSShipmentReportComponentComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="finance-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  !isFinanceApprovalAccess()
                    ? [UserEnum.FINANCE_CONTROLLER, UserEnum.MANAGER]
                    : [Employee.HALA]
                }
                isRoute
                isEmployee={isFinanceApprovalAccess()}
              >
                <FinanceApprovalTabComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route path="/enquiry/">
          <Route
            path="enquiry"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={[UserEnum.SALES_PERSON, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR]}
                  isRoute
                >
                  <CRMRequestTableComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="enquiries"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={
                    !isPricingTeam()
                      ? [
                        UserEnum.SALES_PERSON,
                        UserEnum.MANAGER,
                        UserEnum.SALES_MANAGER,
                        UserEnum.SALES_DIRECTOR,
                      ]
                      : PRICING_TEAM_USERS
                  }
                  isRoute
                  isEmployee={isPricingTeam()}
                >
                  <EnquiryTableComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
          <Route
            path="enquiries/:id"
            element={
              <Suspense fallback={<LoadingComponent />}>
                <AccessControlComponent
                  access={
                    !isPricingTeam()
                      ? [
                        UserEnum.SALES_PERSON,
                        UserEnum.MANAGER,
                        UserEnum.SALES_MANAGER,
                        UserEnum.SALES_DIRECTOR,
                      ]
                      : PRICING_TEAM_USERS
                  }
                  isRoute
                  isEmployee={isPricingTeam()}
                >
                  <EnquiryTabComponentLoadable />
                </AccessControlComponent>
              </Suspense>
            }
          />
        </Route>

        <Route
          path="/customer-complaint"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <CustomerComplaintComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="/add-complaint"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <AddCustomerComplaintComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="/complaint-detail/:id"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]}
              isRoute
            >
              <CustomerComplaintDetailsComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="customer-complaint-report"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ]}
              isRoute
            >
              <CustomerComplaintReportComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="customer-complaint-kpi-report"
          element={
            <AccessControlComponent
              access={[
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ]}
              isRoute
            >
              <CustomerComplaintKpiReportComponentLoadable />
            </AccessControlComponent>
          }
        />
        <Route
          path="/vehicle-assignment"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR, UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF
                  , UserEnum.FLEET_SUPERVISOR
                  , UserEnum.OPERATION_CS_SUPERVISOR
                  , UserEnum.OPERATION_STAFF
                  , UserEnum.OPS_CASH
                ]}
                isRoute
              >
                <VehicleAssignmentTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="bulk-invoice"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.MANAGER]}
                isRoute
              >
                <BulkComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="bayan"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  isBayanTeam()
                    ? [Employee.IMRAN_PASHA, Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN]
                    : [UserEnum.MANAGER, UserEnum.OPS_MANAGER
                      , UserEnum.FLEET_SUPERVISOR
                      , UserEnum.OPERATION_CS_SUPERVISOR
                      , UserEnum.OPERATION_STAFF
                      , UserEnum.OPERATION_SUPERVISOR
                      , UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF
                      , UserEnum.OPS_CASH
                      , UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR
                    ]
                }
                isRoute
                isEmployee={isBayanTeam()}
              >
                <BayanTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="pending-pod"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.SALES_PERSON,
                ]}
                isRoute
                isEmployee={isProdMode() ? true : false}
              >
                <PendingPodComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="shipment-summary"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() || isShipmentSummaryTeam() ? [Employee.MATEEN_PROD, ...SHIPMENT_SUMMARY_TEAM] : [
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.MANIFESTER,
                  UserEnum.ADMIN,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.CSV,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.DATA_LOGGER,
                  UserEnum.QUOTATION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.GATEWAY_USER,
                ]}
                isEmployee={isMateenProdUser() || isShipmentSummaryTeam()}
                isRoute
              >
                <ShipmentSummaryComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="fte-configuration"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[]}
                isRoute
                isAccess={isNewAccessible({
                  employeeIds: FTE_CONFIGURATION_ACCESS,
                })}
              >
                <FteConfigurationComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="barcode-change-request"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  [
                    UserEnum?.OPS_MANAGER,
                    UserEnum?.OPERATION_SUPERVISOR,
                    UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
                    UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum?.MANAGER]}
                isRoute
                isEmployee={isProdMode() ? true : false}
              >
                <BarcodeCancellationComponentLoadable />
              </AccessControlComponent>

            </Suspense>
          }
        />
        <Route
          path="pickup-cancellation"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  [
                    UserEnum?.OPS_MANAGER,
                    UserEnum?.OPERATION_SUPERVISOR,
                    UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
                    UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum?.MANAGER]}
                isRoute
                isEmployee={isProdMode() ? true : false}
              >
                <PickupCancellationComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="marken-table"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMarkenTeam() ? Marken_Team : [UserEnum.GATEWAY_USER]}
                isRoute
                isEmployee={isMarkenTeam()}
              >
                <MarkenTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="marken-details"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMarkenTeam() ? Marken_Team : [UserEnum.GATEWAY_USER]}
                isRoute
                isEmployee={isMarkenTeam()}
              >
                <MarkenFormComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="tracking-history"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.FINANCE,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.CUSTOMER_CARE,

                ]}
                isRoute
              >
                <TrackingHistoryComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="temp-monitoring"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.ADMIN,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                ]}
                isRoute
              >
                <TempMonitoringComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="diagnostics"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.ADMIN,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.IT_SUPPORT,
                ]}
                isRoute
              >
                <DiagnosticsComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="fuel-management"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <FuelManagementComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="fuel-audit"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isRoute
              >
                <FuelAuditComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="odometer"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isEditOdometerTeam() ? EDIT_ODOMETER_TEAM : [
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                ]}
                isEmployee={isEditOdometerTeam()}
                isRoute
              >
                <OdometerTableLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="waybill-exception"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <WaybillExceptionTableComponentLoadable />
            </Suspense>
          }
        />
        <Route
          path="occ-exception-list"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.CUSTOMER_SERVICE,
                ]}
                isEmployee={isMateenProdUser()}
                isAccess={isPricingTeamAccess}
                isRoute
              >
                <OCCExceptionTabComponentLoadable />
              </AccessControlComponent>

            </Suspense>
          }
        />
        <Route
          path="demurrage-charges/occ-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.CUSTOMER_SERVICE,
                ]}
                isEmployee={isMateenProdUser()}
                isAccess={isPricingTeamAccess || isDemurrageOccApprovalAccess}
                isRoute
              >
                <OccApprovalComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="volumetric/approval-config"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  Employee.PANDI,
                  Employee.MATEEN_PROD,
                  Employee.ASIF_PATEL,
                  Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN
                ]}
                isRoute
                isEmployee
              >
                <ApprovalConfigComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="volumetric/volumetric-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>

              <VolumetricApprovalComponentLoadable />
            </Suspense>
          }
        />
        <Route
          path="user-auth-creation"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.IT_SUPPORT]}
                isRoute
              >
                <UserAuthCreationFormLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-dps-pending-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.ADMIN,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  // Changes to be made tomorrow
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                ]}
                isRoute
              >
                <MetaDpsPendingReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-dps-todays-released-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.ADMIN,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.CUSTOMER_SERVICE,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.CSV,
                  UserEnum.SALES_PERSON,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  // Changes to be made tomorrow
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                ]}
                isRoute
              >
                <MetaDpsTodaysReleasedReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-picking-to-oracle-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isProdMode() ? [
                  UserEnum.FINANCE_CONTROLLER,
                  UserEnum.FINANCE,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                ] : [
                  UserEnum.MANAGER,
                ]}
                isRoute
              >
                <MetaPickingToOracleReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-first-mile-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaFirstMileReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-middle-mile-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaMiddleMileReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-last-mile-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaLastMileReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-in-transit-pending-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaInTransitPendingReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-trip-plan-status-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaTripPlanStatusReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        {/* <Route
          path="meta-box-utilization-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaBoxUtilizationReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        /> */}

        <Route
          path="meta-agreement-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  !isMetaAgreementReportAccess()
                    ? [
                      UserEnum.FINANCE,
                      UserEnum.ADMIN,
                      UserEnum.FINANCE_CONTROLLER,
                    ]
                    :
                    [
                      Employee.MATEEN_PROD,
                      Employee.ALANOUD,
                      Employee.FARAH,
                      Employee.ELAF_SARHAN,
                      Employee.ASHWAQ_ALANEZ,
                      Employee.GOPINATH
                    ]
                }
                isRoute
                isEmployee={isMetaAgreementReportAccess()}
              >
                <MetaAgreementReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />


      <Route
          path="meta-manifestation-irs-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={
                  !isMetaIRSManifestationReportAccess()
                    ? [
                      UserEnum.ADMIN,
                       UserEnum.OPERATION_SUPERVISOR,
                        UserEnum.MANAGER,
                         UserEnum.OPS_MANAGER,
                    ]
                    :
                    [
                      Employee.MATEEN_PROD,
                      Employee.HASSAN_ALMIRZA,
                      Employee.GOPINATH
                    ]
                }
                isRoute
                isEmployee={isMetaIRSManifestationReportAccess()}
              >
                <ManifestationIRSReport />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route
          path="meta-fuel-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isFuelReportTeam() ? FUEL_REPORT_TEAM : [
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.DATA_ANALYST, UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isEmployee={isFuelReportTeam()}
                isRoute
              >
                <MetaFuelManagementReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-ftl-ideal-vehicle-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaFtlIdealVehicleReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-daily-scan-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaDailyScanReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-fleet-utilization-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.MANAGER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaFleetUtilizationReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-vehicle-utilization-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                  UserEnum.FINANCE_CONTROLLER,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <MetaVehicleUtilizationReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-vehicle-loading-unloading-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.CUSTOMER_CARE,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <VehicleLoadingUnloadingReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicle-loading-unloading-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.MANAGER,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <NewVehicleLoadingUnloadingReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-driver-tracking-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaDriverTrackingHistoryReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="adhoc-trip"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[]}
                isAccess={(isNewAccessible({
                  employeeIds: AdhocTripTabRoles?.employeeIds
                }))}
              >
                <AdhocTabsComponentLoadable />
              </AccessControlComponent>

            </Suspense>
          }
        />
        <Route
          path="adhoc-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AdhocReportComponentLoadable />
            </Suspense>
          }
        />
        <Route
          path="adhoc-vendor-master"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[]}
                isAccess={(isNewAccessible({
                  employeeIds: AdhocVendor_TripApproval_Roles?.employeeIds
                }))}
              >
                <AdhocVendorMasterComponentLoadable />
              </AccessControlComponent>

            </Suspense>
          }
        />
        <Route
          path="dashboard/driver-dashboard"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <DriverDashboardLoadableComponent />
            </Suspense>
          }
        />
        <Route
          path="dashboard/supervisor-dashboard"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <SupervisorDashboardLoadableComponent />
            </Suspense>
          }
        />
        {/* <Route
          path="delivery-reschedule"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR, UserEnum.SALES_PERSON,
                ]}
                isRoute
              >
                <DeliveryRescheduleTableComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        /> */}
        <Route
          path="ftl-trip-plan"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST,
                  UserEnum.OCC_SOLUTION,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <FTLTripPlanTableLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="idle-vehicles"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isProdMode() ? (
                  isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.OPS_MANAGER,
                    UserEnum.MANAGER,
                    UserEnum.OCC_SOLUTION,
                  ]
                ) : [UserEnum.MANAGER]}
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <IdleVehiclesDashboardLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="idle-vehicles-approval"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isProdMode() ? (
                  isMateenProdUser() || isIdleVehicleExceptionTeam() ? [Employee.MATEEN_PROD, ...IDLE_VEHICLE_EXCEPTION_TEAM] : [
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.FLEET_SUPERVISOR,
                    UserEnum.OPERATION_STAFF,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.OCC_SOLUTION,
                    UserEnum.MANAGER,
                  ]
                ) : [UserEnum.MANAGER]}
                isEmployee={isMateenProdUser() || isIdleVehicleExceptionTeam()}
                isRoute
              >
                <IdleVehiclesApprovalLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="geofencing"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isProdMode() ? (GeoFencingAccess) : [Employee.MATEEN_DEV, Employee.PRANEETH_DEV]}
                isEmployee={true}
                isRoute
              >
                <MapGeofenceSelectorLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="vehicle-gps-history-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] :
                  [
                    UserEnum.OPS_MANAGER,
                    UserEnum.OPERATION_SUPERVISOR,
                    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                    UserEnum.OPERATION_CS_SUPERVISOR,
                    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                    UserEnum.MANAGER,
                  ]
                }
                isEmployee={isMateenProdUser()}
                isRoute
              >
                <VehicleHistoryReportComponentLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="driver-assignment-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              {/* <AccessControlComponent
                access={isMateenProdUser() ? [Employee.MATEEN_PROD] : [
                  UserEnum.OPS_MANAGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_CASH,
                  UserEnum.OPERATOR_CASH_COLLECTOR,
                ]}
                isEmployee={isMateenProdUser()}
                isRoute
              > */}
              <DriverAssignmentReport />
              {/* </AccessControlComponent> */}
            </Suspense>
          }
        />
        <Route
          path="meta-customer-shipper-coordinates-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaCustomerShipperCoordinatesReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-customer-consignee-coordinates-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaCustomerConsigneeCoordinatesReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-gpi-fsc-impact-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaGpiFscImpactReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-handover-sheet-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaHandoverSheetReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-pod-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaPodReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-pod-agreement-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[]}
                isAccess={isPricingTeamAccess}
                isRoute
              >
                <MetaPodAgreementReportLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="meta-manifest-confirmation-pending-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaManifestConfirmationPendingReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-trip-pallet-utilization-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaBoxUtilizationByDateReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-booking-national-address-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaBookingNationalAddressReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-event-at-hub-scan-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaEventAtHubScanReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-suspicious-scan-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaSuspiciousScanReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-booking-national-address-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaBoxUtilizationByDateReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-out-of-location-shipment-scan-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaOutOfLocationShipmentScanReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-courier-trip-stops-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaCourierTripStopsReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-courier-trip-stops-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaCourierTripStopsReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-shipper-consignee-waiting-time-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaShipperConsigneeWaitingTimeReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-vehicle-login-logout-data-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaVehicleLoginAndLogoutDataLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-idle-severity-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaIdleSeverityReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="meta-trip-pallet-utilization-report"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <MetaBoxUtilizationByDateReportLoadable />
            </Suspense>
          }
        />
        <Route
          path="pickup-delivery-heatmap"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <HeatMapComponentLoadable />
            </Suspense>
          }
        />
        <Route
          path="notifications-list"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <NotificationListLoadable />
            </Suspense>
          }
        />
        <Route
          path="invoice-staging"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[UserEnum.MANAGER, UserEnum.FINANCE, UserEnum.FINANCE_CONTROLLER]}
                isRoute
              >
                <InvoiceStagingLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route path="/aims-welcome" element={<AimsOperationWelcome />} />

        {/* A-One Integration */}
        <Route path="a-one/*" element={<AOneRoutes />} />
        {/* Report Routes  */}

        <Route
          path="credit-limit-extension"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.SALES_PERSON,
                ]}
                isRoute
              >
                <CreditLimitExtensionLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />
        <Route
          path="credit-limit-extension-requests"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <AccessControlComponent
                access={[
                  UserEnum.MANAGER,
                  UserEnum.SALES_MANAGER,
                  UserEnum.SALES_DIRECTOR,
                  UserEnum.SALES_PERSON,
                ]}
                isRoute
              >
                <CreditLimitRequestsLoadable />
              </AccessControlComponent>
            </Suspense>
          }
        />

        <Route path="/" element={<LoginComponent />} />
        <Route path="*" element={<NotFoundComponent />} />
      </Route>
      <Route path="/agreement" element={<AgreementComponent />} />
      <Route
        path="invoice-staging-manifest/:waybillNumber"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent
              access={[UserEnum.MANAGER, UserEnum.FINANCE, UserEnum.FINANCE_CONTROLLER]}
              isRoute
            >
              <OperationContext.Provider value={{
                waybillNo: '',
                selectedRow: null,
                fromOperation: true,
              }}>
                <InvoiceStagingManifestComponentLoadable />

              </OperationContext.Provider>
            </AccessControlComponent>
          </Suspense>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
